import util from '@/util'

export default {
  props: {
    timeslot_collection_id: { default: null }, /* required for mixin */
  },
  data: () => ({
    // savingDrag: false,
  }),
  computed: {
    draggablesList: {
      get() {
        return this.related_commitments;
      },
      set(items) {
        console.log( "[DraggableMixin:", this.timeslot_collection_id, "] Got", items);

        /* If a timeslot_collection_id is given, we need should check if item comes from
           another list */
        let foreignItems = items.filter(item => {
          if ( this.timeslot_collection_id === null ) {
            return item.user.timeslotCollectionId;
          }
          return item.user.timeslotCollectionId !== this.timeslot_collection_id
        })
        console.log("[DraggableMixin:" + this.timeslot_collection_id + "]", "foreignItems", foreignItems);

        foreignItems.forEach(item => {
          console.log("[DraggableMixin:" + this.timeslot_collection_id + "]", "commitment_move_to_tsc", item.commitmentId);
          this.$api.commitment_move_to_tsc({
            dst_tsc_id: this.timeslot_collection_id || null,
            commitment_id: item.commitmentId // = item.$id
          })
        })

        /* Also check if item was removed from the list */
        /*
        {
          let currentSet = new Set(items.map(item => item.$id));
          let previousArray = this.commitment_list_all.map(item => item.$id)
          let missingItems = previousArray.filter(x => !currentSet.has(x))
          console.log("[" + this.timeslot_collection_id + "]", "missingItems", missingItems);
        }
        */

        let batch = items.map(item => item.$id)
        this.$emit('save-order', batch, this.timeslot_collection_id)
        console.log("[DraggableMixin:" + this.timeslot_collection_id + "]", "save-order", batch);

        // this.savingDrag = true;
        this.$api.commitment_priorize_batch({
          batch: batch,
        })
        //.then(() => { this.savingDrag = false; });
      }
    },

    related_commitments() {

      const currentUserId = this.$models.user.defaultUserId;

      /* Soviel daten werden garnicht benötigt!! */
      return this.commitment_list_all.filter(item => {
        let is_assigned_to_user = ( item.meta.assignedUserId === currentUserId )
        let is_assigned_to_tsc  = ( item.user.timeslotCollectionId === this.timeslot_collection_id )

        if ( this.timeslot_collection_id === null ) {
          /* This means were looking for unassigned commitments */
          // return is_assigned_to_user && !item.user.timeslotCollectionId;
          is_assigned_to_tsc =  !item.user.timeslotCollectionId;
        }

        // console.log("[related_commitments:" + item.commitmentId + ':' + this.timeslot_collection_id + "]",
        //   item.user.timeslotCollectionId,
        //   is_assigned_to_user,
        //   is_assigned_to_tsc);

        return is_assigned_to_user && is_assigned_to_tsc;
      }).map(commitment => {
        return { ...commitment, $id: commitment.commitmentId }
      }).sort(util.sorter.by_user_prioidx);
    },

    commitment_list_all() {
      return this.$models.commitment.getters.commitment_list_all;
    },
  }
}
